import React from 'react';
import ReactDOM from 'react-dom';
import Root from './containers/Root';
import { hashHistory } from 'react-router';
import { syncHistoryWithStore } from 'react-router-redux';
import configureStore from './redux/configureStore';

const attach = (store, thunk) => (thunk ? thunk(store) : store);

export default class Render {
  static render(makeRoutes, attachingToStore) {
    const element = document.getElementById('root');
    if (element) {
      const store = attach(configureStore(hashHistory), attachingToStore);
      const history = syncHistoryWithStore(hashHistory, store, {
        selectLocationState: state => state.router,
      });

      const routes = makeRoutes(store);

      ReactDOM.unmountComponentAtNode(element);
      ReactDOM.render(
        <Root
          history={history}
          routes={routes}
          store={store}
          data={element.dataset}
        />,
        element
      );

      return store;
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/common/Render.js